import React from 'react';
import styled from 'styled-components';
import { Row, Spin } from 'antd';

const BigIcon = styled(Spin)`
  font-size: 50px;
`;

const LoadingWrapper = styled(({ ...rest }) => <div {...rest} />)`
  display: flex;
  min-height: inherit;
  width: 100%;
  height: inherit;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export function Loading() {
  return (
    <LoadingWrapper data-testid="loading">
      <Row justify="center">
        <BigIcon />
      </Row>
    </LoadingWrapper>
  );
}
